(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-section"] && !Shopify.designMode) return;
  try {
    
/* Parallax Background */
(function(){
  const root = document.getElementById('tt-cta-{{ section.id }}');
  if(!root) return;
  const img = root.querySelector('.tt-cta__img');
  if(!img) return;

  const enable = root.dataset.parallax === 'true';
  if(!enable) return;

  const speed = parseFloat(root.dataset.parallaxSpeed || '1.2');
  const disableMobile = root.dataset.parallaxDisableMobile === 'true';
  const mq = window.matchMedia('(max-width: 990px)');

  function tick(){
    if(disableMobile && mq.matches){ img.style.transform = 'translateY(0)'; return; }
    const rect = root.getBoundingClientRect();
    const offset = rect.top * speed;
    img.style.transform = 'translateY(' + (-offset).toFixed(2) + 'px)';
  }
  tick();
  window.addEventListener('scroll', tick, {passive:true});
  window.addEventListener('resize', tick);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  const h = document.getElementById('tt-header');
  if(!h) return;

  // Only apply sticky logic if enabled
  if(!h.classList.contains('tt-header--sticky')) return;

  function onScroll(){
    const y = window.scrollY;
    if(y > 1){
      h.classList.add('scrolled');
      if(getComputedStyle(h).position !== 'sticky'){ h.classList.add('is-fixed'); }
    } else {
      h.classList.remove('scrolled');
      h.classList.remove('is-fixed');
    }

    // shrink on scroll
    if(y > 80){ h.classList.add('shrink'); }
    else { h.classList.remove('shrink'); }
  }

  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});

  // mobile drawer
  const btn = h.querySelector('.tt-burger');
  const drawer = document.getElementById('tt-drawer');
  if(btn && drawer){
    btn.addEventListener('click', ()=>{
      const open = !drawer.hasAttribute('hidden');
      if(open){ drawer.setAttribute('hidden',''); btn.setAttribute('aria-expanded','false'); }
      else{ drawer.removeAttribute('hidden'); btn.setAttribute('aria-expanded','true'); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-work-slider"] && !Shopify.designMode) return;
  try {
    
/* tiny vanilla controller */
(function(){
  var root  = document.getElementById('ow-{{ section.id }}');
  if(!root) return;

  var track = root.querySelector('.ow__track');
  var prev  = root.querySelector('.ow__prev');
  var next  = root.querySelector('.ow__next');

  var cfg = {
    d: Number(track.dataset.d || 3),
    t: Number(track.dataset.t || 2),
    m: Number(track.dataset.m || 1),
    gap: Number(track.dataset.gap || 24),
    auto: track.dataset.auto === 'true',
    delay: Number(track.dataset.delay || 3000)
  };

  var step = 0;

  function setVars(){
    var total = track.children.length;
    var per = (window.innerWidth <= 640) ? cfg.m : (window.innerWidth <= 990 ? cfg.t : cfg.d);
    if (total <= per) per = Math.max(1, total - 1);         // auto-shrink when items are few

    track.style.setProperty('--per', per);
    track.style.setProperty('--gap', cfg.gap + 'px');

    var s = track.querySelector('.ow__slide');
    var w = s ? s.getBoundingClientRect().width : Math.round(track.clientWidth / Math.max(1, per));
    step = Math.max(1, Math.round(w + cfg.gap));

    var canScroll = (track.scrollWidth - track.clientWidth) > 2;
    root.classList.toggle('ow--no-scroll', !canScroll);
  }

  function go(dir){
    var to  = track.scrollLeft + (dir * step);
    var max = track.scrollWidth - track.clientWidth;
    if (to < 0) to = 0;
    if (to > max) to = 0; // simple loop
    track.scrollTo({ left: to, behavior: 'smooth' });
  }

  next && next.addEventListener('click', function(){ go(+1); restart(); });
  prev && prev.addEventListener('click', function(){ go(-1); restart(); });

  var timer = null;
  function start(){ if(cfg.auto){ stop(); timer = setInterval(function(){ go(+1); }, cfg.delay); } }
  function stop(){ if(timer){ clearInterval(timer); timer = null; } }
  function restart(){ if(cfg.auto){ stop(); start(); } }

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);

  // init
  setVars();
  window.addEventListener('resize', setVars);
  window.addEventListener('load', setVars);
  track.scrollLeft = 0;
  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-quote"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCarousel(root){
    if(!root) return;
    const slides = [...root.querySelectorAll('.ttq__slide')];
    if(!slides.length) return;
    const track = root.querySelector('.ttq__track');
    const btnPrev = root.querySelector('.ttq__prev');
    const btnNext = root.querySelector('.ttq__next');
    const dots = [...root.querySelectorAll('.ttq__dot')];
    let index = 0;
    const auto = root.dataset.auto === 'true';
    const delay = Number(root.dataset.delay || 3500);
    let timer = null;

    function resizeToActive(){
      const inner = slides[index].querySelector('.ttq__inner');
      if(inner) track.style.height = inner.offsetHeight + 'px';
    }
    function show(n){
      index = (n + slides.length) % slides.length;
      slides.forEach((s,i)=>s.classList.toggle('is-active', i===index));
      dots.forEach((d,i)=>d.classList.toggle('is-active', i===index));
      resizeToActive();
    }
    function next(){ show(index+1); restart(); }
    function prev(){ show(index-1); restart(); }
    function start(){ if(auto){ stop(); timer=setInterval(next, delay); } }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function restart(){ if(auto){ stop(); start(); } }

    btnNext?.addEventListener('click', next);
    btnPrev?.addEventListener('click', prev);
    dots.forEach((d,i)=>d.addEventListener('click', ()=>{ show(i); restart(); }));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    show(0);
    resizeToActive();
    start();
    window.addEventListener('resize', resizeToActive);
  }

  document.querySelectorAll('.ttq').forEach(initCarousel);
  document.addEventListener('shopify:section:load', e => initCarousel(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-header"]) return;
  try {
    
document.addEventListener('scroll', function(){
  const h=document.getElementById('tt-header');
  if(!h) return;
  if(window.scrollY>10){h.classList.add('scrolled')}else{h.classList.remove('scrolled')}
});

  } catch(e) { console.error(e); }
})();
})();
